import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ISoftwareFormMeta {
    versionNumber: FormInputMeta;
    softwareIdentificator: FormInputMeta;

}

const softwareFormMeta = {} as ISoftwareFormMeta;

softwareFormMeta.versionNumber = {
    name: "versionNumber",
    type: "text",
    label: "Numéro Version",
    placeholder: "Numéro Version",
    validation: yup.string()
};

softwareFormMeta.softwareIdentificator = {
    name: "softwareIdentificator",
    type: "text",
    label: "Identificateur Logiciel",
    placeholder: "Identificateur Logiciel",
    validation: yup.string()
};

export default softwareFormMeta;